import { LayoutZOrder } from "@buildwithflux/constants";
import { guid } from "@buildwithflux/shared";
export function createRouteData(startElementDataUid, startTerminalDataUid, endElementDataUid, endTerminalDataUid, userUid, uid) {
    return {
        created_at: new Date().getTime(),
        updated_at: new Date().getTime(),
        endpoints: {
            start_element_terminal: {
                uid: guid(),
                element_uid: startElementDataUid,
                terminal_uid: startTerminalDataUid,
            },
            end_element_terminal: {
                uid: guid(),
                element_uid: endElementDataUid,
                terminal_uid: endTerminalDataUid,
            },
        },
        uid: uid || guid(),
        owner_uid: userUid,
        properties: {},
        canAutoRoute: true,
        middleVertices: {
            0: { index: 0, x: 0, y: 0, z: LayoutZOrder.route },
            1: { index: 1, x: 0, y: 0, z: LayoutZOrder.route },
            2: { index: 2, x: 0, y: 0, z: LayoutZOrder.route },
            3: { index: 3, x: 0, y: 0, z: LayoutZOrder.route },
        },
    };
}
//# sourceMappingURL=factory.js.map